export default "__VITE_ASSET__1bb483ae__"